import { getCognitoRole } from 'api/utils/auth';

export const useIsProvider = () => {
  const isProvider = getCognitoRole() === 'PROVIDER';
  return isProvider;
};
